function generateIdFromProducto(producto) {
    return `${producto.nombre}-${producto.categoria}`
      .toLowerCase()
      .replace(/\s+/g, '-')       
      .replace(/[^a-z0-9-]/g, ''); 
  }
  function limpiarTextoParaSlug(texto) {
    return texto
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") 
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-') 
      .replace(/[^a-z0-9-]/g, ''); 
  }
const productosPersianas = [
    {
        nombre: 'Glam Dimout',
        categoria:'Sheer Elegance',
        colores: ['Dark Brown','Onix','Sand','Silver'],
        anchoTela: '3m',
        largoRollo: '50m',
        composicion:'100% Poliéster',
        grosor: 'N/A',
        pesoM2:'195 m² +- 5%',
        images: [
            require ('../../assets/img/productos/sheerElegance/miniaturasSheerElegance/muestra.jpg'),
            require ('../../assets/img/productos/sheerElegance/glamDimout/1.jpg'), 
            require ('../../assets/img/productos/sheerElegance/glamDimout/2.jpg'), 
            require ('../../assets/img/productos/sheerElegance/glamDimout/3.jpg'), 
            require ('../../assets/img/productos/sheerElegance/glamDimout/4.jpg')
        ]
    },{
        nombre: 'Duo Radiance',
        categoria:'Sheer Elegance',
        colores: ['Gold','Grey','Silver','White'],
        anchoTela: '3m',
        largoRollo: '50m',
        composicion:'100% Poliéster',
        grosor: 'N/A',
        pesoM2:'105 m² +- 5%',
        images: [
            require ('../../assets/img/productos/sheerElegance/miniaturasSheerElegance/muestra-img-2.jpg'),
            require ('../../assets/img/productos/sheerElegance/duoRadiance/1.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoRadiance/2.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoRadiance/3.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoRadiance/4.jpg')
        ]
    },{
        nombre: 'Brave Dimout',
        categoria:'Sheer Elegance',
        colores: ['Siver','Navy','Brown','Steel'],
        anchoTela: '2.8m',
        largoRollo: '40m',
        composicion:'100% Poliéster',
        grosor: 'N/A',
        pesoM2:'184 m² +- 5%',
        images: [
            require ('../../assets/img/productos/sheerElegance/miniaturasSheerElegance/muestra-img-3.jpg'),
            require ('../../assets/img/productos/sheerElegance/braveDimout/1.jpg'), 
            require ('../../assets/img/productos/sheerElegance/braveDimout/2.jpg'), 
            require ('../../assets/img/productos/sheerElegance/braveDimout/3.jpg'), 
            require ('../../assets/img/productos/sheerElegance/braveDimout/4.jpg')
        ]
    },{
        nombre: 'Dense Woodlook',
        categoria:'Sheer Elegance',
        colores: ['White Wood','Soft White','Natural Wood','Kakhy','Old Wood','Grey Wood','Oxford','Black Wood'],
        anchoTela: '2.8m',
        largoRollo: '50m',
        composicion:'100% Poliéster',
        grosor: 'N/A',
        pesoM2:'171 m² +- 5%',
        images: [
            require ('../../assets/img/productos/sheerElegance/miniaturasSheerElegance/muestra-img-4.jpg'),
            require ('../../assets/img/productos/sheerElegance/denseWoodlook/1.jpg'), 
            require ('../../assets/img/productos/sheerElegance/denseWoodlook/2.jpg'), 
            require ('../../assets/img/productos/sheerElegance/denseWoodlook/3.jpg'), 
            require ('../../assets/img/productos/sheerElegance/denseWoodlook/4.jpg'),
            require ('../../assets/img/productos/sheerElegance/denseWoodlook/5.jpg'), 
            require ('../../assets/img/productos/sheerElegance/denseWoodlook/6.jpg'), 
            require ('../../assets/img/productos/sheerElegance/denseWoodlook/7.jpg'), 
            require ('../../assets/img/productos/sheerElegance/denseWoodlook/8.jpg')
        ]
    },{
        nombre: 'Genius Dimout',
        categoria:'Sheer Elegance',
        colores: ['Dark Wood','Kakhy','Light Grey','Oxford'],
        anchoTela: '2.8m',
        largoRollo: '40m',
        composicion:'100% Poliéster',
        grosor: 'N/A',
        pesoM2:'142 m² +- 5%',
        images: [
            require ('../../assets/img/productos/sheerElegance/miniaturasSheerElegance/muestra-img-5.jpg'),
            require ('../../assets/img/productos/sheerElegance/geniusDimout/1.jpg'), 
            require ('../../assets/img/productos/sheerElegance/geniusDimout/2.jpg'), 
            require ('../../assets/img/productos/sheerElegance/geniusDimout/3.jpg'), 
            require ('../../assets/img/productos/sheerElegance/geniusDimout/4.jpg')
        ]
    },{
        nombre: 'Lino Dimout',
        categoria:'Sheer Elegance',
        colores: ['White','Ivory','Grey'],
        anchoTela: '2.8m',
        largoRollo: '40m',
        composicion:'100% Poliéster',
        grosor: 'N/A',
        pesoM2:'184 m² +- 5%',
        images: [
            require ('../../assets/img/productos/sheerElegance/miniaturasSheerElegance/muestra-img-6.jpg'),
            require ('../../assets/img/productos/sheerElegance/linoDimout/1.jpg'), 
            require ('../../assets/img/productos/sheerElegance/linoDimout/2.jpg'), 
            require ('../../assets/img/productos/sheerElegance/linoDimout/3.jpg')
        ]
    },{
        nombre: 'Sheer Advantage',
        categoria:'Sheer Elegance',
        colores: ['White','Ivory','Pewter'],
        anchoTela: '3m',
        largoRollo: '30m',
        composicion:'35% Poliéster - 65% PVC',
        grosor: 'N/A',
        pesoM2:'265 m² +- 5%',
        images: [
            require ('../../assets/img/productos/sheerElegance/miniaturasSheerElegance/muestra-img-7.jpg'),
            require ('../../assets/img/productos/sheerElegance/sheerAdvantage/1.jpg'), 
            require ('../../assets/img/productos/sheerElegance/sheerAdvantage/2.jpg'), 
            require ('../../assets/img/productos/sheerElegance/sheerAdvantage/3.jpg')
        ]
    },{
        nombre: 'Royal Dimout',
        categoria:'Sheer Elegance',
        colores: ['Beige','Ivory','Royal Grey','Steel'],
        anchoTela: '2.8m',
        largoRollo: '50m',
        composicion:'100% Poliéster',
        grosor: 'N/A',
        pesoM2:'193 m² +- 5%',
        images: [
            require ('../../assets/img/productos/sheerElegance/miniaturasSheerElegance/muestra-img-8.jpg'),
            require ('../../assets/img/productos/sheerElegance/royalDimout/1.jpg'), 
            require ('../../assets/img/productos/sheerElegance/royalDimout/2.jpg'), 
            require ('../../assets/img/productos/sheerElegance/royalDimout/3.jpg'), 
            require ('../../assets/img/productos/sheerElegance/royalDimout/4.jpg')
        ]
    },{
        nombre: 'Duo Bright',
        categoria:'Sheer Elegance',
        colores: ['Ocaso','Polar','Noche'],
        anchoTela: '3m',
        largoRollo: '45m',
        composicion:'100% Poliéster',
        grosor: '0.55 m',
        pesoM2:'0 m² +- 5%',
        images: [
            require ('../../assets/img/productos/sheerElegance/miniaturasSheerElegance/muestra-img-9.jpg'),
            require ('../../assets/img/productos/sheerElegance/duoBright/1.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoBright/2.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoBright/3.jpg')
        ]
    },{
        nombre: 'Duo Basic',
        categoria:'Sheer Elegance',
        colores: ['Perla','Cream','Lino White','Lino Ivory','Purple','Provincial Blue','Capuccino','Grey','Coffe','Dark Grey','Chocolate','Black'],
        anchoTela: '2.5m',
        largoRollo: '50m',
        composicion:'100% Poliéster',
        grosor: '0.28 mm',
        pesoM2:'Pendiente',
        images: [
            require ('../../assets/img/productos/sheerElegance/miniaturasSheerElegance/muestra-img-10.jpg'),
            require ('../../assets/img/productos/sheerElegance/duoBasic/1.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoBasic/2.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoBasic/3.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoBasic/4.jpg'),
            require ('../../assets/img/productos/sheerElegance/duoBasic/5.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoBasic/6.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoBasic/7.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoBasic/8.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoBasic/9.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoBasic/10.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoBasic/11.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoBasic/12.jpg')
        ]
    },{
        nombre: 'Duo Woodline',
        categoria:'Sheer Elegance',
        colores: ['White Wood','Soft White','Natural Wood','Grey Wood','Kakhy','Old Wood','Oxford','Black Wood'],
        anchoTela: '2.6m | 3m',
        largoRollo: '45m',
        composicion:'100% Poliéster',
        grosor: '0.25 mm',
        pesoM2:'0 m² +- 5%',
        images: [
            require ('../../assets/img/productos/sheerElegance/miniaturasSheerElegance/muestra-img-11.jpg'),
            require ('../../assets/img/productos/sheerElegance/duoWoodline/1.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoWoodline/2.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoWoodline/3.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoWoodline/4.jpg'),
            require ('../../assets/img/productos/sheerElegance/duoWoodline/5.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoWoodline/6.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoWoodline/7.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoWoodline/8.jpg')
        ]
    },{
        nombre: 'Duo BasicXL',
        categoria:'Sheer Elegance',
        colores: ['Perla','Cream','Capuccino','Coffe','Chocolate','Grey','Steel','Dark Blue','Black'],
        anchoTela: '2.5m',
        largoRollo: '50m',
        composicion:'100% Poliéster',
        grosor: '0.28 mm',
        pesoM2:'Pendiente',
        images: [
            require ('../../assets/img/productos/sheerElegance/miniaturasSheerElegance/muestra-img-12.jpg'),
            require ('../../assets/img/productos/sheerElegance/duoBasicXL/1.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoBasicXL/2.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoBasicXL/3.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoBasicXL/4.jpg'),
            require ('../../assets/img/productos/sheerElegance/duoBasicXL/5.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoBasicXL/6.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoBasicXL/7.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoBasicXL/8.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoBasicXL/9.jpg')
        ]
    },{
        nombre: 'Duo Terra',
        categoria:'Sheer Elegance',
        colores: ['Vainilla','Avellana','Steel','Castaña','Moka'],
        anchoTela: '3m',
        largoRollo: '50m',
        composicion:'100% Poliéster',
        grosor: '0.65 mm',
        pesoM2:'0 m² +- 5%',
        images: [
            require ('../../assets/img/productos/sheerElegance/miniaturasSheerElegance/muestra-img-13.jpg'),
            require ('../../assets/img/productos/sheerElegance/duoTerra/1.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoTerra/2.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoTerra/3.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoTerra/4.jpg'),
            require ('../../assets/img/productos/sheerElegance/duoTerra/5.jpg'),
        ]
    },{
        nombre: 'Duo Woods',
        categoria:'Sheer Elegance',
        colores: ['Natural','Kakhy','Grey','Oxford'],
        anchoTela: '3m',
        largoRollo: '50m',
        composicion:'100% Poliéster',
        grosor: '0.40 mm',
        pesoM2:'0 m² +- 5%',
        images: [
            require ('../../assets/img/productos/sheerElegance/duoWoods/1.jpg'),
            require ('../../assets/img/productos/sheerElegance/duoWoods/2.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoWoods/3.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoWoods/4.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoWoods/5.jpg')
        ]
    },{
        nombre: 'Duo Celebrity',
        categoria:'Sheer Elegance',
        colores: ['Marfíl','Pale','Bone Smoky','Smoky'],
        anchoTela: '2.5m',
        largoRollo: '50m',
        composicion:'100% Poliéster',
        grosor: '0.38 mm',
        pesoM2:'0 m² +- 5%',
        images: [
            require ('../../assets/img/productos/sheerElegance/miniaturasSheerElegance/muestra-img-15.jpg'),
            require ('../../assets/img/productos/sheerElegance/duoCelebrity/1.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoCelebrity/2.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoCelebrity/3.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoCelebrity/4.jpg')
        ]
    },{
        nombre: 'Duo Dimout',
        categoria:'Sheer Elegance',
        colores: ['White','Natural','Golden Sand','Kakhy','Light Grey','Oxford','Coffe Brown', 'Brown', 'Black'],
        anchoTela: '3m',
        largoRollo: '45m',
        composicion:'100% Poliéster',
        grosor: '0.55 mm',
        pesoM2:'320 m² +- 5%',
        images: [
            require ('../../assets/img/productos/sheerElegance/miniaturasSheerElegance/muestra-img-16.jpg'),
            require ('../../assets/img/productos/sheerElegance/duoDimout/1.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoDimout/2.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoDimout/3.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoDimout/4.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoDimout/5.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoDimout/6.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoDimout/7.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoDimout/8.jpg'), 
            require ('../../assets/img/productos/sheerElegance/duoDimout/9.jpg')
        ]
    }
    






    //Enrollables
    ,{
        nombre: 'Screen Basic',
        categoria:'Enrollables',
        colores: ['Chalk','Alabaster','Granite','Pebblestone','Pewter','Tobacco','Ebony', 'Ash'],
        anchoTela: '2.0 m | 2.5 m | 3.0 m',
        largoRollo: '30 m',
        composicion:'30% Poliéster - 70% PVC',
        grosor: '0.72 mm',
        pesoM2:'540 m² +- 5%',
        images: [
            require ('../../assets/img/productos/enrollables/screenBasic/muestra.jpg'),
            require ('../../assets/img/productos/enrollables/screenBasic/2.jpg'), 
            require ('../../assets/img/productos/enrollables/screenBasic/3.jpg'), 
            require ('../../assets/img/productos/enrollables/screenBasic/4.jpg'), 
            require ('../../assets/img/productos/enrollables/screenBasic/5.jpg'), 
            require ('../../assets/img/productos/enrollables/screenBasic/6.jpg'), 
            require ('../../assets/img/productos/enrollables/screenBasic/7.jpg'), 
            require ('../../assets/img/productos/enrollables/screenBasic/8.jpg'),  
        ]
    },{
        nombre: 'Screen One',
        categoria:'Enrollables',
        colores: ['Chalk','Alabaster','Granite'],
        anchoTela: '2.5 m',
        largoRollo: '30 m',
        composicion:'30% Poliéster - 70% PVC',
        grosor: 'N/A',
        pesoM2:'520 m² +- 5%',
        images: [
            require ('../../assets/img/productos/enrollables/screenOne/muestra.jpg'),
            require ('../../assets/img/productos/enrollables/screenOne/2.jpg'), 
            require ('../../assets/img/productos/enrollables/screenOne/3.jpg'), 
            require ('../../assets/img/productos/enrollables/screenOne/4.jpg'),
        ]
    },{
        nombre: 'Screen Soft',
        categoria:'Enrollables',
        colores: ['White','White Bone','White Platinum','Bone','Charcoal Grey','Chocolate','Black'],
        anchoTela: '2.0 m | 2.5 m | 3.0 m',
        largoRollo: '30 m',
        composicion:'30% Poliéster - 70% PVC',
        grosor: '0.56 mm',
        pesoM2:'430 m² +- 5%',
        images: [
            require ('../../assets/img/productos/enrollables/screenSoft/muestra.jpg'),
            require ('../../assets/img/productos/enrollables/screenSoft/2.jpg'), 
            require ('../../assets/img/productos/enrollables/screenSoft/3.jpg'), 
            require ('../../assets/img/productos/enrollables/screenSoft/4.jpg'), 
            require ('../../assets/img/productos/enrollables/screenSoft/5.jpg'), 
            require ('../../assets/img/productos/enrollables/screenSoft/6.jpg'), 
            require ('../../assets/img/productos/enrollables/screenSoft/7.jpg'), 
            require ('../../assets/img/productos/enrollables/screenSoft/8.jpg'),
        ]
    },{
        nombre: 'Screen Milan',
        categoria:'Enrollables',
        colores: ['Pewter','Steel','Kakhy','Coffe','Dark Blue'],
        anchoTela: '2.5 m',
        largoRollo: '30 m',
        composicion:'30% Poliéster - 70% PVC',
        grosor: '0.72 mm',
        pesoM2:'430 m² +- 5%',
        images: [
            require ('../../assets/img/productos/enrollables/screenMilan/muestra.jpg'),
            require ('../../assets/img/productos/enrollables/screenMilan/2.jpg'), 
            require ('../../assets/img/productos/enrollables/screenMilan/3.jpg'), 
            require ('../../assets/img/productos/enrollables/screenMilan/4.jpg'), 
            require ('../../assets/img/productos/enrollables/screenMilan/5.jpg'), 
            require ('../../assets/img/productos/enrollables/screenMilan/6.jpg'),
        ]
    },{
        nombre: 'FL Long Beach',
        categoria:'Enrollables',
        colores: ['White','Sand','Grey'],
        anchoTela: '2.5 m',
        largoRollo: '50 m',
        composicion:'100% Poliéster',
        grosor: '0.4 mm',
        pesoM2:'195 m² +- 5%',
        images: [
            require ('../../assets/img/productos/enrollables/flLongBeach/muestra.jpg'),
            require ('../../assets/img/productos/enrollables/flLongBeach/2.jpg'), 
            require ('../../assets/img/productos/enrollables/flLongBeach/3.jpg'), 
            require ('../../assets/img/productos/enrollables/flLongBeach/4.jpg'),
        ]
    },{
        nombre: 'FL Sindey',
        categoria:'Enrollables',
        colores: ['Blanco','Ivory','Light Grey','Gris'],
        anchoTela: '3.0 m',
        largoRollo: '30 m',
        composicion:'100% Poliéster',
        grosor: '0.4 mm',
        pesoM2:'235 m² +- 5%',
        images: [
            require ('../../assets/img/productos/enrollables/flSidney/muestra.jpg'),
            require ('../../assets/img/productos/enrollables/flSidney/2.jpg'), 
            require ('../../assets/img/productos/enrollables/flSidney/3.jpg'), 
            require ('../../assets/img/productos/enrollables/flSidney/4.jpg'), 
            require ('../../assets/img/productos/enrollables/flSidney/5.jpg'),
        ]
    },{
        nombre: 'FL Budelli',
        categoria:'Enrollables',
        colores: ['Pearl','Oyster','Sand','Sheell'],
        anchoTela: '2.2 m',
        largoRollo: '50 m',
        composicion:'100% Poliéster',
        grosor: '0.25 mm',
        pesoM2:'165 m² +- 5%',
        images: [
            require ('../../assets/img/productos/enrollables/flBudelli/muestra.jpg'),
            require ('../../assets/img/productos/enrollables/flBudelli/2.jpg'), 
            require ('../../assets/img/productos/enrollables/flBudelli/3.jpg'), 
            require ('../../assets/img/productos/enrollables/flBudelli/4.jpg'), 
            require ('../../assets/img/productos/enrollables/flBudelli/5.jpg'),
        ]
    },{
        nombre: 'FL Ipanema',
        categoria:'Enrollables',
        colores: ['White','Ivory'],
        anchoTela: '2.5 m',
        largoRollo: '50 m',
        composicion:'100% Poliéster',
        grosor: '0.37 mm',
        pesoM2:'170 m² +- 5%',
        images: [
            require ('../../assets/img/productos/enrollables/flIpanema/muestra.jpg'), 
            require ('../../assets/img/productos/enrollables/flIpanema/2.jpg'), 
            require ('../../assets/img/productos/enrollables/flIpanema/3.jpg')
        ]
    },{
        nombre: 'Bo Ipanema',
        categoria:'Enrollables',
        colores: ['White'],
        anchoTela: '2.5 m',
        largoRollo: '40 m',
        composicion:'100% Poliéster',
        grosor: '0.47 mm',
        pesoM2:'280 m² +- 5%',
        images: [
            require ('../../assets/img/productos/enrollables/flIpanema/muestra.jpg'), 
            require ('../../assets/img/productos/enrollables/flIpanema/2.jpg')
        ]
    },{
        nombre: 'Bo Montreal',
        categoria:'Enrollables',
        colores: ['Chalk','Ivory','Alabaster','Grey','Steel'],
        anchoTela: 'Chalk y Alabaster:2m,2.5m,3m Resto:2.5m, 3m',
        largoRollo: '40 m',
        composicion:'100% Poliéster',
        grosor: '0.48 mm',
        pesoM2:'320 m² +- 5%',
        images: [
            require ('../../assets/img/productos/enrollables/boMontreal/muestra.jpg'), 
            require ('../../assets/img/productos/enrollables/boMontreal/2.jpg'), 
            require ('../../assets/img/productos/enrollables/boMontreal/3.jpg'), 
            require ('../../assets/img/productos/enrollables/boMontreal/4.jpg'), 
            require ('../../assets/img/productos/enrollables/boMontreal/5.jpg'), 
            require ('../../assets/img/productos/enrollables/boMontreal/6.jpg') 
        ]
    },{
        nombre: 'Bo Texture',
        categoria:'Enrollables',
        colores: ['White','Sand','Grey'],
        anchoTela: '2.6 m',
        largoRollo: '30 m',
        composicion:'100% Poliéster',
        grosor: '0.55 mm',
        pesoM2:'340 m² +- 5%',
        images: [
            require ('../../assets/img/productos/enrollables/boTexture/muestra.jpg'), 
            require ('../../assets/img/productos/enrollables/boTexture/2.jpg'), 
            require ('../../assets/img/productos/enrollables/boTexture/3.jpg'),
            require ('../../assets/img/productos/enrollables/boTexture/4.jpg') 
        ]
    },{
        nombre: 'Bo Long Beach',
        categoria:'Enrollables',
        colores: ['White','Ivory','Grey','Stone','Coffe','Samba','Negro','Mandarin','Ocean Blue','Burgundy'],
        anchoTela: '2.0 m | 2.5 m',
        largoRollo: '40 m',
        composicion:'100% Poliéster',
        grosor: '0.48 mm',
        pesoM2:'320 m² +- 5%',
        images: [
            require ('../../assets/img/productos/enrollables/boLongBeach/muestra.jpg'), 
            require ('../../assets/img/productos/enrollables/boLongBeach/2.jpg'), 
            require ('../../assets/img/productos/enrollables/boLongBeach/3.jpg'), 
            require ('../../assets/img/productos/enrollables/boLongBeach/4.jpg'),  
            require ('../../assets/img/productos/enrollables/boLongBeach/5.jpg'),  
            require ('../../assets/img/productos/enrollables/boLongBeach/6.jpg'),  
            require ('../../assets/img/productos/enrollables/boLongBeach/7.jpg'),  
            require ('../../assets/img/productos/enrollables/boLongBeach/8.jpg'),  
            require ('../../assets/img/productos/enrollables/boLongBeach/9.jpg'),  
            require ('../../assets/img/productos/enrollables/boLongBeach/10.jpg')
        ]
    },{
        nombre: 'Bo Ohio',
        categoria: 'Enrollables',
        colores: ['White','Samba','Stone','Steel'],
        anchoTela: '2.5 m',
        largoRollo: '40 m',
        composicion: '100% Poliéster',
        grosor: '0.48 mm',
        pesoM2: '320 m² +- 5',
        images: [
            require ('../../assets/img/productos/enrollables/boOhio/muestra.jpg'),
            require ('../../assets/img/productos/enrollables/boOhio/2.jpg'),
            require ('../../assets/img/productos/enrollables/boOhio/3.jpg'),
            require ('../../assets/img/productos/enrollables/boOhio/4.jpg'),
            require ('../../assets/img/productos/enrollables/boOhio/5.jpg'),
        ]
    },{
        nombre: 'Bo Sidney',
        categoria: 'Enrollables',
        colores: ['White','Ivory','Light Grey','Grey'],
        anchoTela: '3.0 m',
        largoRollo: '30 m',
        composicion: '100% Poliéster',
        grosor: '0.65 mm',
        pesoM2: '410 m² +- 5%',
        images: [
            require ('../../assets/img/productos/enrollables/boSidney/muestra.jpg'),
            require ('../../assets/img/productos/enrollables/boSidney/2.jpg'),
            require ('../../assets/img/productos/enrollables/boSidney/3.jpg'),
            require ('../../assets/img/productos/enrollables/boSidney/4.jpg'),
            require ('../../assets/img/productos/enrollables/boSidney/5.jpg')
        ]
    },{
        nombre: 'Bo Luxury',
        categoria: 'Enrollables',
        colores: ['White','Beige','Samba','Stone','Dark Grey'],
        anchoTela: '3.0 m',
        largoRollo: '30 m',
        composicion: '100% Poliéster',
        grosor: '0.45 mm',
        pesoM2: '410 m² +- 5%',
        images: [
            require ('../../assets/img/productos/enrollables/boLuxury/muestra.jpg'),
            require ('../../assets/img/productos/enrollables/boLuxury/2.jpg'),
            require ('../../assets/img/productos/enrollables/boLuxury/3.jpg'),
            require ('../../assets/img/productos/enrollables/boLuxury/4.jpg'),
            require ('../../assets/img/productos/enrollables/boLuxury/5.jpg'),
            require ('../../assets/img/productos/enrollables/boLuxury/6.jpg')
        ]
    },{
        nombre: 'Bo 500',
        categoria: 'Enrollables',
        colores: ['White','Black','Alabaster','Grey','Dark Grey'],
        anchoTela: '2.0 m | 2.5 m | 3.0 m',
        largoRollo: '30 m',
        composicion: '60% PVC 40% Fibra de Vidrio',
        grosor: '0.38 mm',
        pesoM2: '530 m² +- 5%',
        images: [
            require ('../../assets/img/productos/enrollables/bo500/muestra.jpg'),
            require ('../../assets/img/productos/enrollables/bo500/2.jpg'),
            require ('../../assets/img/productos/enrollables/bo500/3.jpg'),
            require ('../../assets/img/productos/enrollables/bo500/4.jpg'),
            require ('../../assets/img/productos/enrollables/bo500/5.jpg'),
            require ('../../assets/img/productos/enrollables/bo500/6.jpg')
        ]
    },{
        nombre: 'Bo Galaxy',
        categoria: 'Enrollables',
        colores: ['Black Dust','Golden Dust','Silver Dust'],
        anchoTela: '3.0 m',
        largoRollo: '30 m',
        composicion: '100% Poliéster',
        grosor: 'N/A',
        pesoM2: '370 m² +- 5%',
        images: [
            require ('../../assets/img/productos/enrollables/boGalaxy/muestra.jpg'),
            require ('../../assets/img/productos/enrollables/boGalaxy/2.jpg'),
            require ('../../assets/img/productos/enrollables/boGalaxy/3.jpg'),
            require ('../../assets/img/productos/enrollables/boGalaxy/4.jpg')
        ]
    },{
        nombre: 'Bo Stylus',
        categoria: 'Enrollables',
        colores: ['Ivory','Brown','Blue','Black'],
        anchoTela: '3.0 m',
        largoRollo: '30 m',
        composicion: '100% Poliéster',
        grosor: 'N/A',
        pesoM2: '430 m² +- 5%',
        images: [
            require ('../../assets/img/productos/enrollables/boStylus/muestra.jpg'),
            require ('../../assets/img/productos/enrollables/boStylus/2.jpg'),
            require ('../../assets/img/productos/enrollables/boStylus/3.jpg'),
            require ('../../assets/img/productos/enrollables/boStylus/4.jpg'),
            require ('../../assets/img/productos/enrollables/boStylus/5.jpg')
        ]
    },
    
    
    
    
    
    
    
    
    
    
    
    
    {
        nombre: 'Bo Stylus J',
        categoria: 'Panel Japones',
        colores: ['Ivory','Brown','Blue','Black'],
        anchoTela: '3.0 m',
        largoRollo: '30 m',
        composicion: '100% Poliéster',
        grosor: 'N/A',
        pesoM2: '430 m² +- 5%',
        images: [
            require ('../../assets/img/productos/enrollables/boStylus/2.jpg'),
            require ('../../assets/img/productos/enrollables/boStylus/2.jpg'),
            require ('../../assets/img/productos/enrollables/boStylus/3.jpg'),
            require ('../../assets/img/productos/enrollables/boStylus/4.jpg'),
            require ('../../assets/img/productos/enrollables/boStylus/5.jpg')
        ]
    },{
        nombre: 'Screen One',
        categoria:'Panel Japones',
        colores: ['Chalk','Alabaster','Granite'],
        anchoTela: '2.5 m',
        largoRollo: '30 m',
        composicion:'30% Poliéster - 70% PVC',
        grosor: 'N/A',
        pesoM2:'520 m² +- 5%',
        images: [
            require ('../../assets/img/productos/enrollables/screenOne/2.jpg'),
            require ('../../assets/img/productos/enrollables/screenOne/2.jpg'), 
            require ('../../assets/img/productos/enrollables/screenOne/3.jpg'), 
            require ('../../assets/img/productos/enrollables/screenOne/4.jpg'),
        ]
    },{
        nombre: 'Screen Soft',
        categoria:'Panel Japones',
        colores: ['White','White Bone','White Platinum','Bone','Charcoal Grey','Chocolate','Black'],
        anchoTela: '2.0 m | 2.5 m | 3.0 m',
        largoRollo: '30 m',
        composicion:'30% Poliéster - 70% PVC',
        grosor: '0.56 mm',
        pesoM2:'430 m² +- 5%',
        images: [
            require ('../../assets/img/productos/enrollables/screenSoft/2.jpg'),
            require ('../../assets/img/productos/enrollables/screenSoft/2.jpg'), 
            require ('../../assets/img/productos/enrollables/screenSoft/3.jpg'), 
            require ('../../assets/img/productos/enrollables/screenSoft/4.jpg'), 
            require ('../../assets/img/productos/enrollables/screenSoft/5.jpg'), 
            require ('../../assets/img/productos/enrollables/screenSoft/6.jpg'), 
            require ('../../assets/img/productos/enrollables/screenSoft/7.jpg'), 
            require ('../../assets/img/productos/enrollables/screenSoft/8.jpg'),
        ]
    },{
        nombre: 'Screen Milan',
        categoria:'Panel Japones',
        colores: ['Pewter','Steel','Kakhy','Coffe','Dark Blue'],
        anchoTela: '2.5 m',
        largoRollo: '30 m',
        composicion:'30% Poliéster - 70% PVC',
        grosor: '0.72 mm',
        pesoM2:'430 m² +- 5%',
        images: [
            require ('../../assets/img/productos/enrollables/screenMilan/2.jpg'),
            require ('../../assets/img/productos/enrollables/screenMilan/2.jpg'), 
            require ('../../assets/img/productos/enrollables/screenMilan/3.jpg'), 
            require ('../../assets/img/productos/enrollables/screenMilan/4.jpg'), 
            require ('../../assets/img/productos/enrollables/screenMilan/5.jpg'), 
            require ('../../assets/img/productos/enrollables/screenMilan/6.jpg'),
        ]
    },{
        nombre: 'FL Long Beach',
        categoria:'Panel Japones',
        colores: ['White','Sand','Grey'],
        anchoTela: '2.5 m',
        largoRollo: '50 m',
        composicion:'100% Poliéster',
        grosor: '0.4 mm',
        pesoM2:'195 m² +- 5%',
        images: [
            require ('../../assets/img/productos/enrollables/flLongBeach/2.jpg'),
            require ('../../assets/img/productos/enrollables/flLongBeach/2.jpg'), 
            require ('../../assets/img/productos/enrollables/flLongBeach/3.jpg'), 
            require ('../../assets/img/productos/enrollables/flLongBeach/4.jpg'),
        ]
    },{
        nombre: 'FL Sindey',
        categoria:'Panel Japones',
        colores: ['Blanco','Ivory','Light Grey','Gris'],
        anchoTela: '3.0 m',
        largoRollo: '30 m',
        composicion:'100% Poliéster',
        grosor: '0.4 mm',
        pesoM2:'235 m² +- 5%',
        images: [
            require ('../../assets/img/productos/enrollables/flSidney/2.jpg'),
            require ('../../assets/img/productos/enrollables/flSidney/2.jpg'), 
            require ('../../assets/img/productos/enrollables/flSidney/3.jpg'), 
            require ('../../assets/img/productos/enrollables/flSidney/4.jpg'), 
            require ('../../assets/img/productos/enrollables/flSidney/5.jpg'),
        ]
    },{
        nombre: 'FL Budelli',
        categoria:'Panel Japones',
        colores: ['Pearl','Oyster','Sand','Sheell'],
        anchoTela: '2.2 m',
        largoRollo: '50 m',
        composicion:'100% Poliéster',
        grosor: '0.25 mm',
        pesoM2:'165 m² +- 5%',
        images: [
            require ('../../assets/img/productos/enrollables/flBudelli/2.jpg'),
            require ('../../assets/img/productos/enrollables/flBudelli/2.jpg'), 
            require ('../../assets/img/productos/enrollables/flBudelli/3.jpg'), 
            require ('../../assets/img/productos/enrollables/flBudelli/4.jpg'), 
            require ('../../assets/img/productos/enrollables/flBudelli/5.jpg'),
        ]
    },{
        nombre: 'FL Ipanema',
        categoria:'Panel Japones',
        colores: ['White','Ivory'],
        anchoTela: '2.5 m',
        largoRollo: '50 m',
        composicion:'100% Poliéster',
        grosor: '0.37 mm',
        pesoM2:'170 m² +- 5%',
        images: [
            require ('../../assets/img/productos/enrollables/flIpanema/2.jpg'), 
            require ('../../assets/img/productos/enrollables/flIpanema/2.jpg'), 
            require ('../../assets/img/productos/enrollables/flIpanema/3.jpg')
        ]
    },{
        nombre: 'Bo Ipanema',
        categoria:'Panel Japones',
        colores: ['White'],
        anchoTela: '2.5 m',
        largoRollo: '40 m',
        composicion:'100% Poliéster',
        grosor: '0.47 mm',
        pesoM2:'280 m² +- 5%',
        images: [
            require ('../../assets/img/productos/enrollables/flIpanema/2.jpg'), 
            require ('../../assets/img/productos/enrollables/flIpanema/2.jpg')
        ]
    },{
        nombre: 'Bo Montreal',
        categoria:'Panel Japones',
        colores: ['Chalk','Ivory','Alabaster','Grey','Steel'],
        anchoTela: 'Chalk y Alabaster:2m,2.5m,3m Resto:2.5m, 3m',
        largoRollo: '40 m',
        composicion:'100% Poliéster',
        grosor: '0.48 mm',
        pesoM2:'320 m² +- 5%',
        images: [
            require ('../../assets/img/productos/enrollables/boMontreal/2.jpg'), 
            require ('../../assets/img/productos/enrollables/boMontreal/2.jpg'), 
            require ('../../assets/img/productos/enrollables/boMontreal/3.jpg'), 
            require ('../../assets/img/productos/enrollables/boMontreal/4.jpg'), 
            require ('../../assets/img/productos/enrollables/boMontreal/5.jpg'), 
            require ('../../assets/img/productos/enrollables/boMontreal/6.jpg') 
        ]
    },{
        nombre: 'Bo Texture',
        categoria:'Panel Japones',
        colores: ['White','Sand','Grey'],
        anchoTela: '2.6 m',
        largoRollo: '30 m',
        composicion:'100% Poliéster',
        grosor: '0.55 mm',
        pesoM2:'340 m² +- 5%',
        images: [
            require ('../../assets/img/productos/enrollables/boTexture/2.jpg'), 
            require ('../../assets/img/productos/enrollables/boTexture/2.jpg'), 
            require ('../../assets/img/productos/enrollables/boTexture/3.jpg'),
            require ('../../assets/img/productos/enrollables/boTexture/4.jpg') 
        ]
    },{
        nombre: 'Bo Long Beach',
        categoria:'Panel Japones',
        colores: ['White','Ivory','Grey','Stone','Coffe','Samba','Negro','Mandarin','Ocean Blue','Burgundy'],
        anchoTela: '2.0 m | 2.5 m',
        largoRollo: '40 m',
        composicion:'100% Poliéster',
        grosor: '0.48 mm',
        pesoM2:'320 m² +- 5%',
        images: [
            require ('../../assets/img/productos/enrollables/boLongBeach/2.jpg'), 
            require ('../../assets/img/productos/enrollables/boLongBeach/2.jpg'), 
            require ('../../assets/img/productos/enrollables/boLongBeach/3.jpg'), 
            require ('../../assets/img/productos/enrollables/boLongBeach/4.jpg'),  
            require ('../../assets/img/productos/enrollables/boLongBeach/5.jpg'),  
            require ('../../assets/img/productos/enrollables/boLongBeach/6.jpg'),  
            require ('../../assets/img/productos/enrollables/boLongBeach/7.jpg'),  
            require ('../../assets/img/productos/enrollables/boLongBeach/8.jpg'),  
            require ('../../assets/img/productos/enrollables/boLongBeach/9.jpg'),  
            require ('../../assets/img/productos/enrollables/boLongBeach/10.jpg')
        ]
    },{
        nombre: 'Bo Ohio',
        categoria: 'Panel Japones',
        colores: ['White','Samba','Stone','Steel'],
        anchoTela: '2.5 m',
        largoRollo: '40 m',
        composicion: '100% Poliéster',
        grosor: '0.48 mm',
        pesoM2: '320 m² +- 5',
        images: [
            require ('../../assets/img/productos/enrollables/boOhio/2.jpg'),
            require ('../../assets/img/productos/enrollables/boOhio/2.jpg'),
            require ('../../assets/img/productos/enrollables/boOhio/3.jpg'),
            require ('../../assets/img/productos/enrollables/boOhio/4.jpg'),
            require ('../../assets/img/productos/enrollables/boOhio/5.jpg'),
        ]
    },{
        nombre: 'Bo Sidney',
        categoria: 'Panel Japones',
        colores: ['White','Ivory','Light Grey','Grey'],
        anchoTela: '3.0 m',
        largoRollo: '30 m',
        composicion: '100% Poliéster',
        grosor: '0.65 mm',
        pesoM2: '410 m² +- 5%',
        images: [
            require ('../../assets/img/productos/enrollables/boSidney/2.jpg'),
            require ('../../assets/img/productos/enrollables/boSidney/2.jpg'),
            require ('../../assets/img/productos/enrollables/boSidney/3.jpg'),
            require ('../../assets/img/productos/enrollables/boSidney/4.jpg'),
            require ('../../assets/img/productos/enrollables/boSidney/5.jpg')
        ]
    },{
        nombre: 'Bo Luxury',
        categoria: 'Panel Japones',
        colores: ['White','Beige','Samba','Stone','Dark Grey'],
        anchoTela: '3.0 m',
        largoRollo: '30 m',
        composicion: '100% Poliéster',
        grosor: '0.45 mm',
        pesoM2: '410 m² +- 5%',
        images: [
            require ('../../assets/img/productos/enrollables/boLuxury/2.jpg'),
            require ('../../assets/img/productos/enrollables/boLuxury/2.jpg'),
            require ('../../assets/img/productos/enrollables/boLuxury/3.jpg'),
            require ('../../assets/img/productos/enrollables/boLuxury/4.jpg'),
            require ('../../assets/img/productos/enrollables/boLuxury/5.jpg'),
            require ('../../assets/img/productos/enrollables/boLuxury/6.jpg')
        ]
    },{
        nombre: 'Bo 500',
        categoria: 'Panel Japones',
        colores: ['White','Black','Alabaster','Grey','Dark Grey'],
        anchoTela: '2.0 m | 2.5 m | 3.0 m',
        largoRollo: '30 m',
        composicion: '60% PVC 40% Fibra de Vidrio',
        grosor: '0.38 mm',
        pesoM2: '530 m² +- 5%',
        images: [
            require ('../../assets/img/productos/enrollables/bo500/2.jpg'),
            require ('../../assets/img/productos/enrollables/bo500/2.jpg'),
            require ('../../assets/img/productos/enrollables/bo500/3.jpg'),
            require ('../../assets/img/productos/enrollables/bo500/4.jpg'),
            require ('../../assets/img/productos/enrollables/bo500/5.jpg'),
            require ('../../assets/img/productos/enrollables/bo500/6.jpg')
        ]
    },{
        nombre: 'Bo Galaxy',
        categoria: 'Panel Japones',
        colores: ['Black Dust','Golden Dust','Silver Dust'],
        anchoTela: '3.0 m',
        largoRollo: '30 m',
        composicion: '100% Poliéster',
        grosor: 'N/A',
        pesoM2: '370 m² +- 5%',
        images: [
            require ('../../assets/img/productos/enrollables/boGalaxy/2.jpg'),
            require ('../../assets/img/productos/enrollables/boGalaxy/2.jpg'),
            require ('../../assets/img/productos/enrollables/boGalaxy/3.jpg'),
            require ('../../assets/img/productos/enrollables/boGalaxy/4.jpg')
        ]
    },{
        nombre: 'Bo Stylus',
        categoria: 'Panel Japones',
        colores: ['Ivory','Brown','Blue','Black'],
        anchoTela: '3.0 m',
        largoRollo: '30 m',
        composicion: '100% Poliéster',
        grosor: 'N/A',
        pesoM2: '430 m² +- 5%',
        images: [
            require ('../../assets/img/productos/enrollables/boStylus/2.jpg'),
            require ('../../assets/img/productos/enrollables/boStylus/2.jpg'),
            require ('../../assets/img/productos/enrollables/boStylus/3.jpg'),
            require ('../../assets/img/productos/enrollables/boStylus/4.jpg'),
            require ('../../assets/img/productos/enrollables/boStylus/5.jpg')
        ]
    }
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    ,{
        nombre: 'Lava',
        categoria: 'Tejidos Exclusivos',
        colores: ['Ivory','Brown','Blue','Black'],
        anchoTela: '3.0 m',
        largoRollo: '30 m',
        composicion: '100% Poliéster',
        grosor: 'N/A',
        pesoM2: '430 m² +- 5%',
        images: [
            require ('../../assets/img/productos/enrollables/boStylus/2.jpg'),
            require ('../../assets/img/productos/enrollables/boStylus/2.jpg'),
            require ('../../assets/img/productos/enrollables/boStylus/3.jpg'),
            require ('../../assets/img/productos/enrollables/boStylus/4.jpg'),
            require ('../../assets/img/productos/enrollables/boStylus/5.jpg')
        ]
    },
    










].map(producto => ({
    ...producto,
    id: generateIdFromProducto(producto),
    slug: limpiarTextoParaSlug(`${producto.nombre}-${producto.categoria}`),
    categoriaSlug: limpiarTextoParaSlug(producto.categoria)
  }));
export default productosPersianas;